import React from 'react';
import { connect } from 'react-redux';
import { DropDownList } from '@progress/kendo-react-dropdowns';

const initialState = {
    CartLineItemId: "",
    ProductId: "",
    MembershipId: "",
    UserId: "",
    ProductName: "",
    colorObj: {
        description: "",
        colorOptionId: null
    },
    sizeObj: {
        description: "",
        sizeOptionId: null
    },
    ColorId: null,
    Color: "",
    SizeId: null,
    Size: "",
    Cost: "",
    DiscountTypes: "",
    CreateDate: "",
    ImageModel: "",
    LineTotal: "",
    IsFulfilled: "",
    TransactionId: "",
    SuggestedCost: 0,
    ActualCost: "",
    Quantity: 1
}

class Product extends React.Component {    
    constructor(props) {
        super(props);

        this.state = {
            CartLineItemId: "",
            ProductId: this.props.productId,
            MembershipId: "",
            UserId: "",
            ProductName: this.props.title,
            colorObj: {
                description: this.props.product.colors.length > 0? this.props.product.colors[0].description:"",
                colorOptionId: this.props.product.colors.length > 0 ? this.props.product.colors[0].colorOptionId : 0
            },
            sizeObj: {
                description: this.props.product.sizes.length > 0 ? this.props.product.sizes[0].description : "",
                sizeOptionId: this.props.product.sizes.length > 0 ? this.props.product.sizes[0].sizeOptionId : 0
            },
            ColorId: this.props.product.colors.length > 0 ? this.props.product.colors[0].colorOptionId : null,
            Color: this.props.product.colors.length > 0 ? this.props.product.colors[0].description : "",
            SizeId: this.props.product.sizes.length > 0 ? this.props.product.sizes[0].sizeOptionId : null,
            Size: this.props.product.sizes.length > 0 ? this.props.product.sizes[0].description : "",
            Cost: "",
            DiscountTypes: "",
            CreateDate: "",
            ImageModel: this.props.image,
            LineTotal: "",
            IsFulfilled: "",
            TransactionId: "",
            SuggestedCost: 0,
            ActualCost: 0,
            Quantity: 1
        }

    }

    resetColorAndSize = () => {
        this.setState({
            colorObj: {
                description: this.props.product.colors.length > 0 ? this.props.product.colors[0].description : "",
                colorOptionId: this.props.product.colors.length > 0 ? this.props.product.colors[0].colorOptionId : 0
            },
            sizeObj: {
                description: this.props.product.sizes.length > 0 ? this.props.product.sizes[0].description : "",
                sizeOptionId: this.props.product.sizes.length > 0 ? this.props.product.sizes[0].sizeOptionId : 0
            },
            ColorId: this.props.product.colors.length > 0 ? this.props.product.colors[0].colorOptionId : null,
            Color: this.props.product.colors.length > 0 ? this.props.product.colors[0].description : "",
            SizeId: this.props.product.sizes.length > 0 ? this.props.product.sizes[0].sizeOptionId : null,
            Size: this.props.product.sizes.length > 0 ? this.props.product.sizes[0].description : ""
        })
    }

    componentDidMount() {
        this.setState({
            ...initialState
        });
        this.resetColorAndSize();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.product === initialState) {
            this.setState({
                ...initialState
            });
            this.resetColorAndSize();
        }
    }

    colorChange = (event) => {
        let target = event.target;
        const value = target.value;
        this.setState({
            ColorId: value.colorOptionId,
            Color: value.description,
            colorObj: value
        });
    }

    sizeChange = (event) => {
        let target = event.target;
        const value = target.value;
        this.setState({
            SizeId: value.sizeOptionId,
            Size: value.description,
            sizeObj: value
        });
    }

    handleChange = ({ target }) => {
        
        if (target.type == 'number') {

            if (target.name == "Quantity") {

                if (target.valueAsNumber < 1) {
                    target.valueAsNumber = 1;
                } else if (target.valueAsNumber > 99) {
                    target.valueAsNumber = 99
                }
            }
        }

        this.setState({ [target.name]: target.valueAsNumber });
     
    };

    handleSubmit = (event) => {
        event.preventDefault();
        var product = {
            ProductId: this.props.product.productId,
            ProductName: this.props.product.title,
            Quantity: Number(this.state.Quantity),
            Color: this.state.Color,
            Size: this.state.Size,
            ColorId: this.state.ColorId,
            SizeId: this.state.SizeId,
            ImageModel: this.props.product.image,
            SuggestedCost:
                this.props.product.discount ?
                    Number((this.props.product.discount * this.state.Quantity).toFixed(2)) :
                    Number((this.props.product.price * this.state.Quantity).toFixed(2)),
            ActualCost:
                this.props.product.discount ?
                    Number((this.props.product.discount * this.state.Quantity).toFixed(2)) :
                    Number((this.props.product.price * this.state.Quantity).toFixed(2))
        };
        this.props.addToProductList(product);
        this.setState({
            ...initialState
        })
    };

    render() {
        return (
            <div className="row productLineItem">
                <div className="col-md-2">
                    <div>
                        <label>{this.props.product.title}</label> 
                        {
                                this.props.product.image.base64 ?  
                                <img src={this.props.product.image.base64} /> : 
                                <img src="/images/TSCRABackgroundLOGO.png" className="defaultImgHeight" alt="..." />
                        }                       
                    </div>
                </div>
                <div className="col-md-2">
                    {this.props.product.colors.length > 0 ?
                        <div className="product-wrapper">
                            <label>Select Color</label>
                            <span className="product-dropdown">
                                <DropDownList
                                    data={this.props.product.colors}
                                    onChange={this.colorChange}
                                    textField="description"
                                    dataItemKey="colorOptionId"
                                    allowCustom={true}
                                    value={this.state.colorObj}
                                />
                            </span>
                        </div> 
                    : ""}
                </div>
                <div className="col-md-2">
                    {this.props.product.sizes.length > 0 ?
                        <div className="product-wrapper">
                            <label>Select Size</label>
                            <span className="product-dropdown">
                                <DropDownList
                                    data={this.props.product.sizes}
                                    onChange={this.sizeChange}
                                    textField="description"
                                    dataItemKey="sizeOptionId"
                                    allowCustom={true}
                                    value={this.state.sizeObj}
                                />
                            </span>
                        </div>
                    : ""}
                </div>
                <div className="col-md-2">
                    <div>
                        <label>Quantity</label>
                        <input
                            name="Quantity"
                            onChange={this.handleChange}
                            value={this.state.Quantity}
                            type="number"
                            min="1"
                            max="99"
                            step="1"/>
                    </div>
                </div>
                <div className="col-md-2">
                    <div>
                        <label>Price</label>
                        {
                            this.props.product.discount ?
                                <p className="productPrice">${(this.props.product.discount * this.state.Quantity).toFixed(2)}</p> :
                                <p className="productPrice">${(this.props.product.price * this.state.Quantity).toFixed(2)}</p>
                        }
                    </div>
                </div>
                <div className="col-md-2 buttonContainer">
                    <button onClick={(event) => this.handleSubmit(event)} className="admin-k-button">
                        <i className="fas fa-plus"></i>
                        <span>ADD</span>
                    </button>
                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {
    return {
        purchaseAndRenewals: state.purchaseAndRenewals
    };
}

export default connect(mapStateToProps, null)(Product);